import { render } from "./SettingGoalModal.vue?vue&type=template&id=6208df8a&scoped=true"
import script from "./SettingGoalModal.vue?vue&type=script&lang=js"
export * from "./SettingGoalModal.vue?vue&type=script&lang=js"

import "./SettingGoalModal.vue?vue&type=style&index=0&id=6208df8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6208df8a"]])

export default __exports__